import "./previewPublicPath";
import "./index.css";

import { CssBaseline } from "@material-ui/core";
import { deDE } from "@material-ui/core/locale";
import { ThemeProvider, createTheme } from "@material-ui/core/styles";
import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";

import App from "./App";

const theme = createTheme(
  {
    palette: {
      primary: { main: "#00b5e2" },
      background: { default: "#f5f7f9" },
    },
    typography: { fontFamily: 'Manrope, "Segoe UI", Arial, sans-serif' },
    overrides: {
      MuiDialog: {
        paper: {
          borderRadius: 14,
          boxShadow: "0 24px 64px rgba(23, 42, 58, 0.24)",
          overflow: "hidden",
        },
      },
      MuiDialogTitle: {
        root: {
          padding: "22px 26px 18px",
          fontWeight: 800,
          borderBottom: "1px solid rgba(20, 48, 68, 0.12)",
        },
      },
      MuiDialogContent: {
        root: {
          padding: "22px 26px",
        },
        dividers: {
          borderTop: "none",
          borderBottom: "1px solid rgba(20, 48, 68, 0.12)",
        },
      },
      MuiDialogActions: {
        root: {
          padding: "14px 26px",
          backgroundColor: "#fafcfd",
        },
      },
      MuiTextField: {
        root: {
          "& .MuiInputBase-root": {
            borderRadius: 6,
          },
          "& .MuiInput-underline:before": {
            borderBottomColor: "rgba(20, 48, 68, 0.30)",
          },
          "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
            borderBottomColor: "#00b5e2",
          },
        },
      },
      MuiButton: {
        root: {
          borderRadius: 5,
          fontWeight: 800,
          letterSpacing: 0.25,
        },
        contained: {
          boxShadow: "none",
          "&:hover": { boxShadow: "0 5px 14px rgba(0, 91, 125, 0.22)" },
        },
      },
      MuiFormControlLabel: {
        label: { fontSize: "0.92rem" },
      },
    },
  },
  deDE
);

ReactDOM.render(
  <ThemeProvider theme={theme}>
    <CssBaseline />
    <BrowserRouter basename={window.location.pathname.startsWith("/cms-preview/") ? "/cms-preview" : undefined}>
      <App />
    </BrowserRouter>
  </ThemeProvider>,
  document.getElementById("root")
);
